<h2 mat-dialog-title class="font-weight-bolder">{{data.title}}</h2>
<mat-dialog-content>
    <form class="style-form" [formGroup]="exportFeaturesForm">
        <mat-form-field appearance="fill" class="formats-select">
            <mat-label>Data Format</mat-label>
            <mat-select formControlName="format">
                <mat-option *ngFor="let format of this.formats" [value]="format">
                    {{ format.text }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <br>

        <div *ngIf="this.multipleGeometryTypes && this.exportFeaturesForm.get('format').value.format === 'shp'" class="warning-shapefile">
            Different geometry types can’t be exported in the same shapefile. Please select a geometry type to export from the dropdown below
        </div>
        <mat-form-field *ngIf="this.multipleGeometryTypes && this.exportFeaturesForm.get('format').value.format === 'shp'" appearance="fill" class="formats-select">
            <mat-label>Geometry Type</mat-label>
            <mat-select formControlName="geometryType">
                <mat-option *ngFor="let geometryType of this.geometryTypes" [value]="geometryType">
                    {{ geometryType.text }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="dialogActions">
    <button matButton="elevated" mat-dialog-close >Cancel</button>
    <button matButton="filled" color="primary" (click)="exportLayer()"
            [mat-dialog-close]="true">Export
    </button>
</mat-dialog-actions>
